import React from "react";
import { Card } from "@shopify/polaris";
import { Col, Row } from "reactstrap";
import Mollie from "../../assets/integrations/mollie.png";
import Layout from "./Layout";
const Gateway = () => {
  const listCheckout = [
    {
      title: "Checkout for Online Shops",
      description: "Accept online payments today",
      logo: Mollie,
      crispEvent: "Mollie",
    },
  ];
  return (
    <div style={{ marginTop: "10px" }}>
      <Card sectioned title="Gateway">
        <Row>
          {listCheckout.map((item, index) => {
            return (
              <Col md="4">
                <Layout
                  title={item.title}
                  description={item.description}
                  logo={item.logo}
                  crispEvent={item.crispEvent}
                />
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export default Gateway;
